'use strict';

angular.module('home.collapseCategoryDescription', []);
